import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import ContactForm from '../components/ContactForm';
import { Mail, Phone, MapPin, Calendar, Building2 } from 'lucide-react';
import '../styles/Contact.css';

const Contact = () => {
  return (
    <div className="contact-page" data-testid="contact-page">
      <Navbar />
      
      <section className="contact-hero">
        <div className="container">
          <div className="hero-content fade-in-up">
            <h1 className="page-title" data-testid="contact-title">Get in Touch</h1>
            <p className="page-subtitle" data-testid="contact-subtitle">
              Let's discuss your project and see how we can help you build something great
            </p>
          </div>
        </div>
      </section>

      <section className="contact-content">
        <div className="container">
          <div className="contact-grid">
            <div className="contact-info">
              <h2>Let's talk about your project</h2>
              <p className="contact-intro">
                Whether you're a startup looking to build your MVP or an enterprise seeking a development partner, we'd love to hear from you.
              </p>

              <div className="contact-methods">
                <div className="contact-method" data-testid="contact-method-email">
                  <div className="method-icon">
                    <Mail size={24} />
                  </div>
                  <div className="method-content">
                    <h4>Email Us</h4>
                    <a href="mailto:contact@BigSoftTech.in">contact@BigSoftTech.in</a>
                  </div>
                </div>

                <div className="contact-method" data-testid="contact-method-phone">
                  <div className="method-icon">
                    <Phone size={24} />
                  </div>
                  <div className="method-content">
                    <h4>Call Us</h4>
                    <a href="tel:+9105324050303">+91 05324050303</a>
                  </div>
                </div>

                <div className="contact-method" data-testid="contact-method-prayagraj">
                  <div className="method-icon">
                    <Building2 size={24} />
                  </div>
                  <div className="method-content">
                    <h4>Prayagraj Office</h4>
                    <p>Civil Lines, Prayagraj</p>
                    <p>Uttar Pradesh, India</p>
                  </div>
                </div>

                <div className="contact-method" data-testid="contact-method-noida">
                  <div className="method-icon">
                    <MapPin size={24} />
                  </div>
                  <div className="method-content">
                    <h4>Noida Office</h4>
                    <p>Sector 62, Noida</p>
                    <p>Uttar Pradesh, India</p>
                  </div>
                </div>

                <div className="contact-method" data-testid="contact-method-calendar">
                  <div className="method-icon">
                    <Calendar size={24} />
                  </div>
                  <div className="method-content">
                    <h4>Schedule a Call</h4>
                    <p>Book a free 30-minute consultation</p>
                  </div>
                </div>
              </div>

              <div className="business-hours">
                <h4>Business Hours</h4>
                <p>Monday - Friday: 9:00 AM - 6:00 PM IST</p>
                <p>Saturday: 10:00 AM - 4:00 PM IST</p>
                <p>Sunday: Closed</p>
              </div>
            </div>

            <div className="contact-form-wrapper">
              <ContactForm />
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default Contact;